
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/marketing/subscribers",
      function () {
        return require("private-next-pages/admin/marketing/subscribers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/marketing/subscribers"])
      });
    }
  